import React, { FunctionComponent, MouseEvent, RefObject, useEffect, useState } from 'react';

import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import 'common/scroll-helper/ScrollHelper.scss';

interface Props {
    direction: 'top' | 'bottom';
    position: 'top' | 'bottom';
    parent: RefObject<HTMLElement>;
}

export const ScrollHelper: FunctionComponent<Props> = ({ direction, position, parent }) => {
    const { t } = useTranslation('common/scroll-helper');

    const [show, setShow] = useState(false);

    const scrollHelperClassnames = classnames('r4e-scroll-helper', {
        top: position === 'top',
        bottom: position === 'bottom',
        show,
    });

    const iconClassnames = classnames('icon', {
        'icon-arrow-to-bottom': direction === 'bottom',
        'icon-arrow-to-top': direction === 'top',
    });

    const onScroll = (e: MouseEvent): void => {
        if (direction === 'top') {
            parent.current!.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            parent.current!.scrollTo({ top: parent.current!.scrollHeight, behavior: 'smooth' });
        }
    };

    useEffect(() => {
        const SCROLL_DELTA = 100;

        if (parent.current) {
            /* eslint-disable no-param-reassign */
            parent.current.onscroll = (): void => {
                let value;

                if (direction === 'top') {
                    value = parent.current!.scrollTop;
                } else {
                    value = parent.current!.scrollHeight - parent.current!.scrollTop - parent.current!.clientHeight;
                }

                if (value > SCROLL_DELTA) {
                    setShow(true);
                } else {
                    setShow(false);
                }
            };
            /* eslint-enable no-param-reassign */
        }
    }, [parent, setShow, direction]);

    return (
        <div className={scrollHelperClassnames}>
            <button type="button" className="helper" onClick={onScroll}>
                {direction === 'top' ? t('SCROLL_TO_TOP') : t('SCROLL_TO_BOTTOM')} <i className={iconClassnames} />
            </button>
        </div>
    );
};
